import React from "react";
import GoogleMap from "@/components/map/google/google-map";
import { useParams } from "react-router-dom";
import GoogleMap2D from "../map/google/google-map-2D";

function ExplorationFlutterWindowLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-chatpanel">
      {children}
    </div>
  );
}

const ExplorationMapFlutterPage: React.FC = () => {
  const { venueCode } = useParams();
  console.log("ExplorationPage venueCode", venueCode)
  return (
    <ExplorationFlutterWindowLayout
      children={
        <GoogleMap2D venueCode={venueCode} isFlutter={true} />
      }
    ></ExplorationFlutterWindowLayout>
  );
};

export default ExplorationMapFlutterPage;
